import 'slick-carousel'
import TAGGED from "../modules/tagged_content"

const[ w, d, l, content, mq ] = [ window, document, location, 'products', window.matchMedia('(max-width: 1049px)')];

//クリッカブルマップ用スライダー
const mapSlider = {
  obj:'.clickable-map__slider',
  init() {
    $(this.obj).slick({
      autoplay: false,
      fade: false,
      centerMode: false,
      pauseOnHover: true,
      adaptiveHeight: false,
      // variableWidth: true,
      prevArrow: `<div class="slick-prev">
      <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18.207" height="5.854" viewBox="0 0 18.207 5.854"><path d="M-14534.576,725.607h-18.207l5.854-5.854.707.707-4.146,4.146h15.793Z" transform="translate(14552.783 -719.754)""/></svg>
      </div>`,
      nextArrow: `<div class="slick-next">
      <svg class="icon" width="18.207" height="5.854" viewBox="0 0 18.207 5.854"  xmlns="http://www.w3.org/2000/svg"><path d="m-14533.838 725.419h-18.207v-1h15.793l-4.146-4.146.707-.707z" transform="translate(14552.045 -719.565)"/></svg>
      </div>`,
      speed: 600,
      cssEase: 'ease-in-out'
    })
  },
  go (index) {
    $(this.obj).slick('slickGoTo', index - 1 );
  },
  getIndex (){
    return $(this.obj).slick('slickCurrentSlide');
  }
}

const tagList = tags => {
  const $tags = $('<div class="tags"></div>');

  if ( mq.matches ) {
    tags = tags.slice(0,4);
  } else {
    tags = tags.slice(0,6);
  }

  tags.forEach( tag => {
    const $tag = $('<span class="tag"/>');
    $tag.text( tag ).appendTo( $tags );
  });

  return $tags[0].outerHTML;
};

//タグ一覧のタイトル
const tagTitle = () => {
  if(!location.search) return false;
  let params = location.search.substr(1).split('&');
  params.map( v => {
    const p=v.split('=');
    params[p[0]]=p[1]
  });
  return decodeURI(params.tag);
}

const accordionNav = () => {
  //製品一覧ナビ アコーディオン
  if( mq.matches ){
    $('.nav-products-head').each( function(){
      const $indicator = $(`<button class="nav-products-head__indicator">`)
      if( this.querySelectorAll('.nav-products-head__titleWrap').length ) {
        $(this).append( $indicator )
      }
      $(this).find('.nav-products-head__body').slideUp();
      $indicator.on('click', ()=>{
        $(this).find('.nav-products-head__body').slideToggle()
        $indicator.toggleClass('is-active')
      });
    });
  }
}

//一覧
const list_init = () => {

    // 一覧ページのテンプレート(Vue template)
    const itemTemplate = `
    <div id="main" class="column-3-4">
      <div class="${content}-list__wrap">
        <h3 class="${content}-list__title">${tagTitle()}</h3>
        <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
          <div class="${content}-item" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
            <a class="${content}-item__link" :href="article.href">
              <figure class="${content}-item__img">
                <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
                  <img :src="article.thumb" width="200">
                </div>
              </figure>
              <div class="${content}-item__body">
                <div class="${content}-item__title">
                  <span class="subject">
                    {{ article.title | truncate }}
                    <span class="new" v-if="article.is_new">NEW</span>
                  </span>
                  <span class="desc">{{ article.desc | truncate( 40 ) }}</span>
                </div>
              </div>
            </a>
          </div>
        </transition-group>
        <pagination
          v-if="totalPage > 1"
          :paged="paged"
          :total-page="totalPage"
          :total-item="totalItem"
          :item-count="pagedArticles.length"
          :prevText="'Prev'"
          :nextText="'Next'"
          @change="pageChange"
        />
      </div>
    </div>
  `

  TAGGED({
    perpage: 12,
    related: false, // int or false
    taglist_disp_detail: false, // head / foot / both
    taglist_disp_list: false, // head / foot / both
    taglist_minimumTagAmount : 12, // タグの最低表示数
    taglist_hideUselessTags : 4, // 最低使用回数
    itemTemplate,
    callback() {
      // フリーブロックを追加する
      $.getFreeBlock({xml:'b_content_content2.xml'}).then( blocks => {
        let $container = $('#container','.is--list')
        if( blocks.mainhead && blocks.mainhead.length ) $container.prepend( $(blocks.mainhead) )
        if( blocks.mainfoot && blocks.mainfoot.length ) $container.append( $(blocks.mainfoot) )
        $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

        //製品一覧ナビ
        accordionNav();
      });
    }
  })
}


//詳細
const detail_init = async post_id => {

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    let the_id = document.body.getAttribute('class').replace(/^.+is--article-([\d]+)(.+)?$/,'$1')
    let codingPageArr = [1,2,3,4,5,6,7,8,9,10]
    const is_codingPage = () => codingPageArr.indexOf( parseInt( the_id ) ) !== -1;
    const is_userEdit = () => codingPageArr.indexOf( parseInt( the_id ) ) == -1;

    //コーディングページ　クラス付与
    if( is_codingPage() )  $('body').addClass('is-codingpage');
    // ユーザー更新ページ　クラス付与
    if( is_userEdit() )  $('body').addClass('is-useredit');
  }

  //製品一覧ナビ
  accordionNav();

  //タグソート製品一覧
  if (w.load['loadHtml']) {
    w.load['loadHtml'].then(() => {

      //関連製品
      const $relatedContainer = $('.products-type__list[data-plugin="getArticles"]');

      const getProducts = $.getJSON('/asset/api/getArticles/', {
        content: 'products',
        exclude: $relatedContainer.data('exclude')
      });

      getProducts.then((items) => {
        let filterTag = $relatedContainer.data('filterTag');

        const productsItem = items.filter(item => {
          const keywords = item.keywords || [];
          return keywords.indexOf(filterTag) !== -1;
        });

        $.each(productsItem, (i, item) => {
          const $item = $(`
            <li class="products-type__item">
              <a href="${item.href}" class="link">
                <figure class="products-type__img">
                  <div class="products-type__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220">
                  </div>
                </figure>
                <div class="products-type__body">
                  <span class="subject">${item.title}</span>
                  ${item.keywords ? tagList(item.keywords) : ''}
                </div>
                <!-- /.products-type__body -->
              </a>
            </li>
            <!-- /.products-type__item -->
          `);
          $relatedContainer.append($item);
        });

      });
    });
  }

  //クリッカブルマップ用スライダー slick実行
  if( w.load['loadHtml'] ) {

    $.when( w.load['loadHtml'] ).then(() => {
      let makeItem = item => $(`
        <div class="clickable-map-item">
          <a href="${item.href}" class="clickable-map-item__link">
            <figure class="clickable-map-item__img">
              <div class="clickable-map-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="400" loading="lazy"></div>
            </figure>
            <div class="clickable-map-item__body">
              <span class="subject">${item.title.str_truncate(24)}</span>
              <span class="desc">${item.desc}</span>
            </div>
          </a>
        </div>
      `)[0]
      const $container = $('.clickable-map__slider[data-plugin="getArticles"]');
      const $clickableLinks = $('.clickable-map__img a.is-link');
      const getPartsArticle = $.getJSON('/asset/api/getArticles/',{
        content: $container[0].dataset.content,
        post_id: $container[0].dataset.articles
      });
      getPartsArticle.then( partsArticles => {
        $container.empty();
        partsArticles.sort( (a,b) => a.id - b.id);
        partsArticles.forEach( article => $container.append( makeItem( article ) )
      );

        mapSlider.init();

        $clickableLinks.each( (i,link) => {
          const index = parseInt( link.id.slice(-2) );
          $(link).on('click', () => {
            mapSlider.go(index);
            return false;
          });
        });

        // ページ読み込みの設定。スライダーのインデックスと同じIDのクリッカブルリンクにクラス追加
        $clickableLinks.filter( (i,v) => {
          // クリッカブルリンクのID取得
          let index = parseInt( v.getAttribute('id').slice(-2) ) - 1; // 1から始まっているのでシフト
          return index === mapSlider.getIndex();
        }).addClass('is-active');

        // スライダーが動いたらクリッカブルリンクのクラス付け替え
        $(mapSlider.obj).on('beforeChange', (e, slick, currentSlide, nextSlide) => {
          $clickableLinks.each( function() {
            // クリッカブルリンクのID取得
            let index = parseInt( this.getAttribute('id').slice(-2) ) - 1; // 1から始まっているのでシフト
            // 次のスライドIDと同じならクラス追加
            if( index === nextSlide ) $(this).addClass('is-active');
            // それ以外はクラス削除
            else $(this).removeClass('is-active');
          });
        });
      });

    });
  }


};

const init = () => {

}

export default function PRODUCTS() {
  $(() => {
    init()
    if (w.query_string('article')) detail_init(w.query_string('article'));
    if (!w.query_string('article') && d.body.classList.contains('is--list')) list_init();
  })
};